document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelector(".splide.ticker_slider")) {
    let tickerSplide = new Splide(".splide.ticker_slider", {
      type: "loop",
      perPage: 2,
      arrows: false,
      speed: 400,
      pagination: false,
      autoplay: true,
      interval: 3000,
      pauseOnHover: false,
      fixedHeight: 100,
      mediaQuery: "min",
      breakpoints: {
        576: {
          perPage: 4,
        },
        768: {
          perPage: 5,
        },
        992: {
          perPage: 5,
        },
      },
      gap: "20px",
    });

    tickerSplide.mount();
  }

  let bannerElement = document.querySelector(".splide.banner_slider");

  if (bannerElement) {
    let bannerSplide = new Splide(".splide.banner_slider", {
      type: "loop",
      perPage: 4,
      arrows: false,
      pagination: false,
      autoWidth: true,
      focus    : 0,
      omitEnd  : true,
      gap: "1.5rem",
      autoScroll: { speed: 0.5, pauseOnHover: false },
      
      fixedHeight: 100,
      mediaQuery: "min",
      // autoplay: true,
      // focus:"center",
      // interval: 10000,
      breakpoints: {
        0: {
          perPage: 3,
        },
        390: {
          perPage: 4,
        },
        576: {
          perPage: 4,
        },
        768: {
          perPage: 3,
        },
        992: {
          perPage: 1,
        },
      },
    });

    // bannerSplide.mount();
    bannerSplide.mount(window.splide.Extensions);
  }

  let footerElement = document.querySelector(".splide.footer_slider");

  if (footerElement) {
    let footerSplide = new Splide(".splide.footer_slider", {
      type: "loop",
      perPage: 4,
      arrows: false,
      pagination: false,
      autoWidth: true,
      focus    : 0,
      omitEnd  : true,
      gap: "1.5rem",
      autoScroll: { speed: 0.5, pauseOnHover: false },
      
      fixedHeight: 100,
      mediaQuery: "min",
      // autoplay: true,
      // focus:"center",
      // interval: 10000,
      breakpoints: {
        0: {
          perPage: 3,
        },
        390: {
          perPage: 3,
        },
        576: {
          perPage: 3,
        },
        768: {
          perPage: 3,
        },
        992: {
          perPage: 3,
        },
      },
    });

    // footerSplide.mount();
    footerSplide.mount(window.splide.Extensions);
  }

  let credibilityElement = document.querySelector(".splide.credibility_slider");

  if (credibilityElement) {
    let autoScrollEnabled = window.matchMedia("(max-width: 767px)").matches;

    let credibilitySplide = new Splide(".splide.credibility_slider", {
      type: "loop",
      perPage: 4,
      arrows: false,
      pagination: false,
      autoWidth: true,
      focus    : 0,
      omitEnd  : true,
      gap: "1.5rem",
      autoScroll: { speed: 0.5, pauseOnHover: false },
      breakpoints: {
        0: { perPage: 3 },
        390: { perPage: 3 },
        576: { perPage: 4 },
        768: { perPage: 5 },
        992: { perPage: 5 },
      }
    
    });

    // credibilitySplide.mount();
    credibilitySplide.mount(window.splide.Extensions);
  }
});
